module.exports = __webpack_public_path__ + "static/img/car_7_6_box@3x.e643149d.png";